// @flow
import * as React from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components4/lib/Link/Link';
import styles from './LoggedOut.module.scss';

type Props = {
    openLoginModal: Function,
    openSignUpModal: Function,
};

const LoggedOut = ({ openLoginModal, openSignUpModal }: Props) => {
    return (
        <div className={styles['logged-out-controls']}>
            <Link className={styles['link-default']} onClick={openLoginModal} primaryWeak>
                <FormattedMessage id="log_in" />
            </Link>
            <Button className={styles['button-default']} onClick={openSignUpModal} primary e2e="headerJoinButton">
                <FormattedMessage id="sign_up" />
            </Button>
        </div>
    );
};

export default React.memo<Props>(LoggedOut, isEqual);
